import React from 'react';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import './CheckoutLayout.css';

export default function CheckoutLayout({ merchantName, logoText, children }) {
  return (
    <div className="checkout-page">
      <div className="checkout-card">
        <aside className="checkout-sidebar">
          <div className="sidebar-top">
            <div className="merchant-logo">{logoText || 'PG'}</div>
            <h1 className="merchant-name">{merchantName || 'Merchant'}</h1>
          </div>
          <div className="sidebar-bottom">
            <SafetyCertificateOutlined className="secure-icon" />
            <span>Secure Checkout</span>
          </div>
        </aside>
        <main className="checkout-main">{children}</main>
      </div>
    </div>
  );
}
